function guid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0,
			v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}
const getFileName = (file) => {
  return file.replace(/(.*\/)*([^.]+).*/ig, '$2')
}
const getFileExp = (file) => {
  if(!file) return 'other'
  const index = file.lastIndexOf('.')
  return file.substr(index + 1).toLowerCase()
}
const isImg = (type) => {
  const imgs = ['image/png', 'image/jpeg', 'image/gif', 'jpg', 'png', 'gif', 'jpeg']
  return imgs.some(img => img === type.toLowerCase())
}
const isAudio = (type) => {
  const audios = ['audio/mpeg', 'audio/wav', 'mp3', 'wav', 'wma']
  return audios.some(au => au === type.toLowerCase())
}
const isVideo = (type) => {
  const vides = ['video/mp4', 'video/mpeg', 'mp4', 'avi', 'mov', 'flv']
  return vides.some(v => v === type.toLowerCase())
}
const isPdf = (type) => {
  const pdfs = ['pdf']
  return pdfs.some(v => v === type.toLowerCase())
}
const getFileType = (type) => {
  let t = 'file'
  if (isImg(type)) {
    t = 'img'
    return t
  }
  if (isAudio(type)) {
    t = 'audio'
    return t
  }
  if (isVideo(type)) {
    t = 'video'
    return t
  }
  if (isPdf(type)) {
    t = 'pdf'
    return t
  }
  return t
}
const getFileSize = (value) => {
  if(!value) return ''
  const s = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const e = Math.floor(Math.log(value) / Math.log(1024))
  return (value / Math.pow(1024, Math.floor(e))).toFixed(2) + ' ' + s[e]
}
const getTypeIcon = (type) => {
  const icon = {
      '1': 'img.png',
      '2': 'music.png',
      '3': 'mov.png',
      '4': 'file.png',
      '5': 'other.png'
  }
  return icon[type]
}
const base64Encode = (url) => {
  return window.btoa(url);
}
const getMedias = (str) => {
  const imgReg = /<img.*?src=[\\"|\\'](.*?)[\\"|\\']?\s.*?>/gi
  const audioReg = /<audio.*?src=[\\"|\\'](.*?)[\\"|\\']?\s.*?>/gi
  const videoReg = /<video.*?src=[\\"|\\'](.*?)[\\"|\\']?\s.*?>/gi
  if(!str) return{
    txt:'',
    imgList:[],
    audioList:[],
    videoList:[]
  }
  const txt = str.replace(/<img.*?>/g, '')||''
  const imgList = str.match(imgReg)?.map((img) => {
    return {
      id:guid(),
      path:img.replace(imgReg, `$1`)
    }
  })||[]
  const audioList = str.match(audioReg)?.map((audio) => {
    return {
      id:guid(),
      path:audio.replace(audioReg, `$1`)
    }
  })||[]
  const videoList = str.match(videoReg)?.map((video) => {
    return {
      id:guid(),
      coverPath:'',
      path:video.replace(videoReg, `$1`)
    }
  })||[]
  return {
    txt,imgList,audioList,videoList
  }
}
const isUrl=(str) =>{
  var v = new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i');
  return v.test(str);
}

export { guid,getFileName, getFileExp, isImg, isAudio, isVideo,isPdf, getFileType, getFileSize,getTypeIcon,base64Encode,getMedias,isUrl }
